
import toastr from 'toastr';

angular.module("persons_information_groups")

    .controller("PersonsInformationGroupsListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'uiGridTreeViewConstants', 'gridService', '$stateParams', 'modalService', '$uibModal', '$filter', '$translate', '$state', 'logService',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, uiGridTreeViewConstants, gridService, $stateParams, modalService, $uibModal, $filter, $translate, $state, logService) {
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("INFORMATION_GROUPS_WRITE");
        $scope.entity_type = $stateParams.entity_type;

        var subtitle = "";
        if ($scope.entity_type == "persons") {
            subtitle = $filter('translate')('events.tasks.persons');
        } else if($scope.entity_type == "events") {
            subtitle = $filter('translate')('events.title');
        }
        $rootScope.title = $filter('translate')('persons_information_groups.title') + " - " + subtitle;

        $rootScope.breadcrumb = [
            { title: $filter('translate')('persons_information_groups.title')  }
        ];

        $scope.gridOptions = {
            pdfTitle: $filter('translate')('persons_information_groups.title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            enableSorting: true,
            showTreeExpandNoChildren: true,
            paginationPageSizes: [15, 30, 50],
            paginationPageSize: 15,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, exporterSuppressExport: true },
                { name: 'order', width: 40, displayName: $filter('translate')('persons_information_groups.order'), enableFiltering: false, enableHiding: true },
                {
                    name: 'icon', displayName: $filter('translate')('persons_information_groups.icon'),
                    cellTemplate: '<div  class="ui-grid-cell-contents">' +
                        '<i class="{{row.entity.icon}} text-primary m-l-sm" ></i>' +
                        '</div>', width: 60,
                    enableFiltering: false, enableHiding: false
                },
                { name: 'name', displayName: $filter('translate')('persons_information_groups.name'), enableFiltering: true, enableHiding: false },
                {
                    name: 'use_in_search', displayName: $filter('translate')('persons_information_groups.use_in_search'),
                    cellTemplate: gridService.yesNoTemplate('use_in_search'),
                    enableFiltering: false, enableHiding: false
                },
                {
                    name: 'notify_in_list', displayName: $filter('translate')('persons_information_groups.notify_in_list'),
                    cellTemplate: gridService.yesNoTemplate('notify_in_list'),
                    enableFiltering: false, enableHiding: false
                },
                {
                    name: 'is_required_field', displayName: $filter('translate')('persons_information_groups.is_required_field'),
                    cellTemplate: gridService.yesNoTemplate('is_required_field'),
                    enableFiltering: false, enableHiding: false, action: 'ng-if="grid.appScope.entity_type == correspondence"',
                },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('persons_information_groups.button_edit'), action: 'ng-click="grid.appScope.goToEdit(row.entity)"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('persons_information_groups.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                options.entity_type = $stateParams.entity_type;
                return Restangular.all('InformationsGroups').getList(options);                                                
            }
        };

        $scope.goToEdit = function (rowEntity) {
            logService.debug(rowEntity);
            $state.go("persons_information_groups.edit", { person_information_group_id: rowEntity.person_information_group_id, id: rowEntity.id, entity_type: $stateParams.entity_type });
        }


        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;            
            modalService.confirm({
                title: $filter('translate')('persons_information_groups.button_delete'),
                message: $filter('translate')('persons_information_groups.delete_message') +" "+ $scope.name + "?",
                onAccept: function () {
                    Restangular.one('InformationsGroups', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('persons_information_groups.delete_success'));
                        $scope.gridOptions.data =
                             $scope.gridOptions.data.filter(function (el) { return el.id != $scope.id; });
                    }, function (response) {
                        logService.error("Error with status code", response.status);
                        alert("Error al borrar")
                    });
                }
            });

        };
        
    }])

;